import React from 'react';
import { Link } from 'react-router-dom';

import MobileDevicesList from './MobileDevicesList';
import { ManagerPermission } from '../permission-profiles/permission';
import FeatureButton from '../utils/FeatureButton';
import { useAuth } from './hooks/useAuth';

const MobileDevicesPage: React.FC = () => {
    const { auth, pendingActions } = useAuth();

    const mobileDevicesPostCounter = pendingActions.mobileDevicesPost ? pendingActions.mobileDevicesPost : 0;

    return (
        <main>
            <nav className="wfp-breadcrumbs">
                <ol className="breadcrumbs--wrapper">
                    <li className="breadcrumbs--item">
                        <Link className="breadcrumbs--link" to="/home">
                            <span>Home</span>
                        </Link>
                    </li>
                    <li className="breadcrumbs--item">
                        <span className="breadcrumbs--last">Mobile Devices</span>
                    </li>
                </ol>
            </nav>
            <div className="row">
                <h3 className="col-sm-4">Mobile Devices</h3>
                <div className="col-sm-8 tr">
                    <FeatureButton
                        counter={mobileDevicesPostCounter.toString()}
                        linkTo={'/mobile-devices/import'}
                        manager={auth.manager}
                        restrictedToFeatures={[
                            ManagerPermission.mobileDevicesCreateUpdatePark,
                            ManagerPermission.mobileDevicesCreateUpdatePost,
                        ]}
                        title={`Import`}
                    />
                </div>
            </div>
            <MobileDevicesList />
        </main>
    );
};

export default MobileDevicesPage;
